<template>
  <div class="col-lg-12">
    <div class="hpanel">
      <div class="panel-heading"></div>
      <div class="panel-body">
        <div>
          <v-tabs v-model="active" slider-color="primary">
            <v-tab key="gate_step_1" ripple>
              <small>Step 1 - Member Details</small>
            </v-tab>
            <v-tab key="gate_step_2" ripple>
              <small>Step 2 - Residency</small>
            </v-tab>
            <v-tab key="gate_step_3" ripple>
              <small>Step 3 - Vehicle Entry Fees</small>
            </v-tab>
            <v-tab key="gate_step_4" ripple>
              <small>Step 4 - Accommodation/Camping</small>
            </v-tab>
            <v-tab key="gate_step_5" ripple>
              <small>Step 5 - Activities</small>
            </v-tab>
            <v-tab
              v-if="proofOfResidency.length < 0"
              key="proofresidency"
              ripple
            >
              <small>Step 6 - Proof of Residency</small>
            </v-tab>
            <v-tab key="gate_step_6" ripple>
              <small>Step 6 - Approval</small>
            </v-tab>
            <v-tab-item key="gate_step_1">
              <v-card flat>
                <v-layout row wrap v-if="route === 'PostponeBooking'">
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container fluid>
                      <v-autocomplete
                        label="Members"
                        v-model="gate_pass.member"
                        :items="bookingMembers"
                        :rules="[(v) => !!v || 'A Member is required']"
                        required
                        item-text="full_name"
                        item-value="member"
                        :return-object="true"
                        :loading="$loadingTrue"
                        :disabled="true"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container fluid>
                      <v-card>
                        <v-container>
                          <v-layout row wrap>
                            <v-flex lg6 md6 sm12 xs12>
                              <v-container>
                                <v-img
                                  v-if="
                                    gate_pass.member.hasOwnProperty(
                                      'profile_image'
                                    ) === false ||
                                    gate_pass.member.profile_image === null
                                  "
                                  width="80%"
                                  src="https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn.pixabay.com%2Fphoto%2F2016%2F08%2F08%2F09%2F17%2Favatar-1577909_960_720.png&f=1"
                                  alt=""
                                ></v-img>
                                <v-img
                                  v-else
                                  :src="gate_pass.member.profile_image"
                                  class="img-rounded"
                                  alt=""
                                  width="100%"
                                ></v-img>
                              </v-container>
                            </v-flex>
                            <v-flex lg6 md6 sm12 xs12>
                              <v-container>
                                <p>
                                  <b>Name:</b> {{ gate_pass.member.full_name }}
                                  {{ gate_pass.member.company_name }}
                                </p>
                                <p>
                                  <b>Level:</b> {{ gate_pass.member.level }}
                                </p>
                                <p>
                                  <b>Residence:</b>
                                  {{ gate_pass.member.residence }}
                                </p>
                                <p>
                                  <b>Persons:</b>
                                  {{ gate_pass.member.family_count }}
                                </p>
                                <p>
                                  <b>Package:</b> {{ gate_pass.member.setting }}
                                </p>
                                <p style="color: #ea6901">
                                  <b>Expiry Date:</b>
                                  {{
                                    formated_date(gate_pass.member.expiry_date)
                                  }}
                                </p>
                                <p>
                                  <b>Entry Discount:</b>
                                  {{ gate_pass.member.entry_discount }}%
                                </p>
                                <p>
                                  <b>Activity Discount:</b>
                                  {{ gate_pass.member.activity_discount }}%
                                </p>
                                <p>
                                  <b>Accommodation Discount:</b>
                                  {{ gate_pass.member.accommodation_discount }}%
                                </p>
                              </v-container>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-container>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container>
                      <v-dialog
                        ref="dialog"
                        persistent
                        v-model="modal1"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="gate_pass.check_in"
                      >
                        <v-text-field
                          slot="activator"
                          label="Check-in"
                          v-model="gate_pass.check_in"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          v-model="gate_pass.check_in"
                          :min="start_date"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal1 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="
                              $refs.dialog.save(gate_pass.check_in),
                                endDate(gate_pass.check_in)
                            "
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container>
                      <v-text-field
                        slot="activator"
                        label="Check-out"
                        v-model="gate_pass.check_out"
                        readonly
                        :disabled="true"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-container fluid>
                    <v-autocomplete
                      label="Select Destination"
                      v-model="gate_pass.destination"
                      :items="allDestinations"
                      :rules="[(v) => !!v || 'Item is required']"
                      required
                      item-text="destination_name"
                      item-value="destination_public_id"
                      :loading="$loadingTrue"
                      :disabled="true"
                      @change="checkDestination"
                    ></v-autocomplete>
                  </v-container>
                  <v-flex lg12 md12 sm12 xs12>
                    <v-container fluid>
                      <v-text-field
                        v-model="gate_pass.promo_code"
                        label="Promo Code"
                        :disabled="true"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg12 md6 sm12 xs12>
                    <v-container fluid>
                      <v-textarea
                        v-model="gate_pass.note"
                        label="Notes"
                        :disabled="true"
                      ></v-textarea>
                    </v-container>
                  </v-flex>
                </v-layout>

                <v-layout v-else row wrap>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container fluid>
                      <v-autocomplete
                        label="Members"
                        v-model="gate_pass.member"
                        :items="bookingMembers"
                        :rules="[(v) => !!v || 'A Member is required']"
                        required
                        item-text="full_name"
                        item-value="member"
                        :return-object="true"
                        :loading="$loadingTrue"
                      ></v-autocomplete>
                    </v-container>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container fluid>
                      <v-card>
                        <v-container>
                          <v-layout row wrap>
                            <v-flex lg6 md6 sm12 xs12>
                              <v-container>
                                <v-img
                                  v-if="
                                    gate_pass.member.hasOwnProperty(
                                      'profile_image'
                                    ) === false ||
                                    gate_pass.member.profile_image === null
                                  "
                                  width="80%"
                                  src="https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fcdn.pixabay.com%2Fphoto%2F2016%2F08%2F08%2F09%2F17%2Favatar-1577909_960_720.png&f=1"
                                  alt=""
                                ></v-img>
                                <v-img
                                  v-else
                                  :src="gate_pass.member.profile_image"
                                  class="img-rounded"
                                  alt=""
                                  width="100%"
                                ></v-img>
                              </v-container>
                            </v-flex>
                            <v-flex lg6 md6 sm12 xs12>
                              <v-container>
                                <p>
                                  <b>Name:</b> {{ gate_pass.member.full_name }}
                                  {{ gate_pass.member.company_name }}
                                </p>
                                <p>
                                  <b>Level:</b> {{ gate_pass.member.level }}
                                </p>
                                <p>
                                  <b>Residence:</b>
                                  {{ gate_pass.member.residence }}
                                </p>
                                <p>
                                  <b>Persons:</b>
                                  {{ gate_pass.member.family_count }}
                                </p>
                                <p>
                                  <b>Package:</b> {{ gate_pass.member.setting }}
                                </p>
                                <p style="color: #ea6901">
                                  <b>Expiry Date:</b>
                                  {{
                                    formated_date(gate_pass.member.expiry_date)
                                  }}
                                </p>
                                <p>
                                  <b>Entry Discount:</b>
                                  {{ gate_pass.member.entry_discount }}%
                                </p>
                                <p>
                                  <b>Activity Discount:</b>
                                  {{ gate_pass.member.activity_discount }}%
                                </p>
                                <p>
                                  <b>Accommodation Discount:</b>
                                  {{ gate_pass.member.accommodation_discount }}%
                                </p>
                              </v-container>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-container>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container>
                      <v-dialog
                        ref="dialog"
                        persistent
                        v-model="modal1"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="gate_pass.check_in"
                      >
                        <v-text-field
                          slot="activator"
                          label="Check-in"
                          v-model="gate_pass.check_in"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          v-model="gate_pass.check_in"
                          :min="start_date"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal1 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialog.save(gate_pass.check_in)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-flex lg6 md6 sm12 xs12>
                    <v-container>
                      <v-dialog
                        ref="dialog1"
                        persistent
                        v-model="modal2"
                        lazy
                        full-width
                        width="290px"
                        :return-value.sync="gate_pass.check_out"
                      >
                        <v-text-field
                          slot="activator"
                          label="Check-out"
                          v-model="gate_pass.check_out"
                          readonly
                        ></v-text-field>
                        <v-date-picker
                          v-model="gate_pass.check_out"
                          :min="gate_pass.check_in"
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="modal2 = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            :depressed="true"
                            flat
                            color="primary"
                            @click="$refs.dialog1.save(gate_pass.check_out)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-container>
                  </v-flex>
                  <v-container fluid>
                    <v-autocomplete
                      label="Select Destination"
                      v-model="gate_pass.destination"
                      :items="allDestinations"
                      :rules="[(v) => !!v || 'Item is required']"
                      required
                      item-text="destination_name"
                      item-value="destination_public_id"
                      :loading="$loadingTrue"
                      @change="checkDestination"
                    ></v-autocomplete>
                  </v-container>
                  <v-flex lg12 md12 sm12 xs12>
                    <v-container fluid>
                      <v-text-field
                        v-model="gate_pass.promo_code"
                        label="Promo Code"
                      ></v-text-field>
                    </v-container>
                  </v-flex>
                  <v-flex lg12 md6 sm12 xs12>
                    <v-container fluid>
                      <v-textarea
                        v-model="gate_pass.note"
                        label="Notes"
                      ></v-textarea>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-card>
              <v-layout row wrap>
                <v-flex lg11 md11></v-flex>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="nextTab()" fab round color="primary"
                    ><v-icon>navigate_next</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item key="gate_step_2">
              <conservation-fees></conservation-fees>
              <v-layout row wrap>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="previousTab()" fab round color="secondary"
                    ><v-icon>navigate_before</v-icon></v-btn
                  >
                </v-flex>
                <v-flex lg10 md10></v-flex>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="nextTab()" fab round color="primary"
                    ><v-icon>navigate_next</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item key="gate_step_3">
              <vehicle-fees
                :check_in="gate_pass.check_in"
                :check_out="gate_pass.check_out"
              ></vehicle-fees>
              <v-layout row wrap>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="previousTab()" fab round color="secondary"
                    ><v-icon>navigate_before</v-icon></v-btn
                  >
                </v-flex>
                <v-flex lg10 md10></v-flex>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="nextTab()" fab round color="primary"
                    ><v-icon>navigate_next</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item key="gate_step_4">
              <v-card flat>
                <facility-booking></facility-booking>
              </v-card>
              <v-layout row wrap>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="previousTab()" fab round color="secondary"
                    ><v-icon>navigate_before</v-icon></v-btn
                  >
                </v-flex>
                <v-flex lg10 md10></v-flex>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="nextTab()" fab round color="primary"
                    ><v-icon>navigate_next</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item key="gate_step_5">
              <v-card flat>
                <inventory-booking></inventory-booking>
              </v-card>
              <v-layout row wrap>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="previousTab()" fab round color="secondary"
                    ><v-icon>navigate_before</v-icon></v-btn
                  >
                </v-flex>
                <v-flex lg10 md10></v-flex>
                <v-flex lg1 md1 sm6 xs6>
                  <v-btn @click="nextTab()" fab round color="primary"
                    ><v-icon>navigate_next</v-icon></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item key="proofresidency" v-if="proofOfResidency.length > 0">
              <v-card flat>
                <residency-proof></residency-proof>
                <v-layout row wrap>
                  <v-flex lg1 md1 sm6 xs6>
                    <v-btn @click="previousTab()" fab round color="secondary"
                      ><v-icon>navigate_before</v-icon></v-btn
                    >
                  </v-flex>
                  <v-flex lg10 md10></v-flex>
                  <v-flex lg1 md1 sm6 xs6>
                    <v-btn @click="nextTab()" fab round color="primary"
                      ><v-icon>navigate_next</v-icon></v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-card>
            </v-tab-item>
            <v-tab-item key="gate_step_6">
              <v-card flat>
                <div class="row">
                  <div class="col-md-12">
                    <table
                      cellpadding="1"
                      cellspacing="1"
                      class="table table-bordered"
                    >
                      <thead>
                        <tr>
                          <td>Entry</td>
                          <td>Entry Discount</td>
                          <td>Guests</td>
                          <td>Total Amount</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <b>Conservation Fees </b> for
                            {{
                              getDays(gate_pass.check_in, gate_pass.check_out)
                            }}
                            days
                          </td>
                          <td>{{ gate_pass.member.entry_discount }}%</td>
                          <td>{{ getCoservationGuests() }}</td>
                          <td>
                            {{ $localCurrency }}
                            {{
                              MemberConservationTotal(
                                gate_pass.member.entry_discount
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <table>
                            <thead>
                              <tr>
                                <td>Residency</td>
                                <td>No of guests</td>
                                <td>Amount</td>
                                <td>Discount</td>
                                <td>Total Payable</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(c_fees, idx) in allConservationFees"
                                :key="'c_fee' + idx"
                              >
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ c_fees.payment_person }}
                                </td>
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ c_fees.payment_guests }}
                                </td>
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ $localCurrency }}
                                  {{
                                    $roundOff(
                                      convert1(
                                        c_fees.payment_person_currency,
                                        c_fees.payment_person_amount
                                      ).amount.toFixed(2)
                                    )
                                  }}
                                </td>
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ c_fees.payment_person_discount }}%
                                </td>
                                <td v-if="c_fees.payment_guests > 0">
                                  {{ $localCurrency }}
                                  {{
                                    $roundOff(
                                      convert1(
                                        c_fees.payment_person_currency,
                                        conservationAmount(
                                          c_fees.payment_person_discount,
                                          c_fees.payment_guests,
                                          c_fees.payment_person_amount
                                        )
                                      ).amount.toFixed(2)
                                    )
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </tr>
                        <tr>
                          <td>
                            <b>Vehicle Fees </b>for
                            {{
                              getDays(gate_pass.check_in, gate_pass.check_out)
                            }}
                            days
                          </td>
                          <td></td>
                          <td>{{ getVehicleTotals() }}</td>
                          <td>
                            {{ $localCurrency }}
                            {{
                              vehicleTotal
                                .toFixed(2)
                                .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
                            }}
                          </td>
                        </tr>
                        <tr>
                          <table>
                            <thead>
                              <tr>
                                <td>Vehicle Type</td>
                                <td>No of Vehicles</td>
                                <td>Amount</td>
                                <td>Discount</td>
                                <td>Total Payable</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(v_fees, idx) in allVehicles"
                                :key="'v_fee' + idx"
                              >
                                <td v-if="v_fees.vehicles > 0">
                                  {{ v_fees.vehicle_charge_category }}
                                </td>
                                <td v-if="v_fees.vehicles > 0">
                                  {{ v_fees.vehicles }}
                                </td>
                                <td v-if="v_fees.vehicles > 0">
                                  {{ $localCurrency }}
                                  {{
                                    $roundOff(
                                      convert1(
                                        v_fees.vehicle_charge_cost_currency,
                                        v_fees.vehicle_charge_category_cost
                                      ).amount.toFixed(2)
                                    )
                                  }}
                                </td>
                                <td v-if="v_fees.vehicles > 0">
                                  {{ v_fees.discount }}%
                                </td>
                                <td v-if="v_fees.vehicles > 0">
                                  {{ $localCurrency }}
                                  {{
                                    $roundOff(
                                      convert1(
                                        v_fees.vehicle_charge_cost_currency,
                                        conservationAmount(
                                          v_fees.discount,
                                          v_fees.vehicles,
                                          v_fees.vehicle_charge_category_cost
                                        )
                                      ).amount.toFixed(2)
                                    )
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </tr>
                        <tr>
                          <td><b>Accommodation</b></td>
                          <td>Accommodation Discount</td>
                          <!--                        <td></td>-->
                          <!--                        <td></td>-->
                        </tr>
                        <tr
                          v-for="(accommodation, key) in chosenFacilities"
                          :key="'acc' + key"
                        >
                          <td>{{ accommodation.name }}</td>
                          <td width="40px">
                            {{ gate_pass.member.accommodation_discount }}%
                          </td>
                          <td>
                            {{
                              Number(accommodation.children) +
                              Number(accommodation.adults)
                            }}
                          </td>
                          <!--                        <td>{{$localCurrency}} {{$roundOff(facilityTotal(accommodation))}}</td>-->
                          <td>
                            {{ $localCurrency }}
                            {{
                              $roundOff(
                                findMemberAccommodationDiscount(
                                  accommodation,
                                  gate_pass.member.accommodation_discount
                                )
                              )
                            }}
                          </td>
                        </tr>

                        <tr></tr>
                        <tr>
                          <td><b>Activities</b></td>
                          <td>Activity Discount</td>
                        </tr>
                        <tr
                          v-for="(activity, key) in chosenInventory"
                          :key="'act' + key"
                        >
                          <td>{{ activity.name }}</td>
                          <td width="40px">
                            {{ gate_pass.member.activity_discount }}%
                          </td>
                          <td>
                            {{
                              Number(activity.children) +
                              Number(activity.adults) +
                              Number(activity.extra_pax_children) +
                              Number(activity.extra_pax_adults)
                            }}
                          </td>
                          <td>
                            {{ $localCurrency }}
                            {{
                              $roundOff(
                                findMemberActivityDiscount(
                                  activity,
                                  gate_pass.member.activity_discount
                                )
                              )
                            }}
                          </td>
                        </tr>

                        <tr></tr>
                            <tr v-if="proofOfResidency.length > 0">
                          <td>
                            <b>Proof Of residency </b>
                          </td>
                        </tr>
                        <tr v-if="proofOfResidency.length > 0">
                          <table>
                            <thead>
                              <tr>
                                <td>Residency</td>
                                 <td>Point Of Proof</td>
                                <td>First Name</td>
                                <td>Last Name</td>
                                <td>Document Id</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(proof, idx) in proofOfResidency"
                                :key="'proof' + idx"
                              >
                                <td v-if="proof.first_name != '' && proof.last_name!='' &&  proof.document_id!='' "> {{ proof.payment_person }}</td>
                                <td v-if="proof.first_name != '' && proof.last_name!='' &&  proof.document_id!='' "> {{ proof.proof_point }}</td>
                                <td v-if="proof.first_name != '' && proof.last_name!='' &&  proof.document_id!='' ">
                                  {{ proof.first_name }}
                                </td>
                                <td v-if="proof.first_name != '' && proof.last_name!='' &&  proof.document_id!='' ">
                                  {{ proof.last_name }}
                                </td>
                                <td v-if="proof.first_name != '' && proof.last_name!='' &&  proof.document_id!='' ">{{ proof.payment_person }}</td>
                                 <td v-if="proof.first_name != '' && proof.last_name!='' &&  proof.document_id!='' ">
                                  {{ proof.document_id}}
                                </td>
                                
                              </tr>
                            </tbody>
                          </table>
                        </tr>
                        <tr></tr>
                        <tr>
                          <td>
                            <b>Destination : </b>
                            {{ this.gate_pass.destination_name }}
                          </td>
                        </tr>
                        <tr>
                          <td><h2>Total</h2></td>
                          <td></td>
                          <td></td>
                          <td>
                            <h2>
                              {{ $localCurrency }}
                              {{ $roundOff(MemberTotalPrice.toFixed(2)) }}
                            </h2>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <div
                        class="col-md-4 col-lg-offset-2"
                        v-if="route === 'EditBooking'"
                      >
                        <v-switch
                          v-model="gate_pass.send_mail"
                          label="Send Email to client"
                        >
                        </v-switch>
                      </div>
                      <div class="col-sm-8">
                        <!--<v-btn :depressed="true" color="primary"  @click.prevent="doBooking()" :loading="this.$store.state.LoadingStore.loading">Complete Booking</v-btn>-->
                        <v-btn
                          :depressed="true"
                          color="primary"
                          v-if="route === 'NewBooking'"
                          @click.prevent="doBooking()"
                          :loading="this.$store.state.LoadingStore.loading"
                          >Complete Booking</v-btn
                        >
                        <v-btn
                          :depressed="true"
                          color="error"
                          v-if="route === 'EditBooking'"
                          @click.prevent="doBooking()"
                          :loading="this.$store.state.LoadingStore.loading"
                          >Amend Booking</v-btn
                        >
                        <v-btn
                          :depressed="true"
                          color="info"
                          v-if="route === 'PostponeBooking'"
                          @click.prevent="postponeBooking()"
                          :loading="this.$store.state.LoadingStore.loading"
                          >Postpone Booking</v-btn
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
              <v-snackbar
                :multi-line="true"
                :right="true"
                :vertical="true"
                :timeout="6000"
                color="error"
                v-model="snackbar"
              >
                Destination must be provided
                <v-btn flat @click="snackbar = false"> Close </v-btn>
              </v-snackbar>
            </v-tab-item>
          </v-tabs>
        </div>
      </div>
    </div>
    {{ updateMemberBooking }}
  </div>
</template>

<script>
import FacilityBooking from "./FacilityBooking";
import Datepicker from "vuejs-datepicker";
import InventoryBooking from "./InventoryBooking";
import ConservationFees from "./ConservationFees";
import VehicleFees from "./VehicleFees";
import ResidencyProof from "./ResidencyProof";
export default {
  components: {
    VehicleFees,
    ConservationFees,
    InventoryBooking,
    FacilityBooking,
    Datepicker,
    "residency-proof": ResidencyProof,
  },
  name: "member-booking",
  data() {
    return {
      route: this.$route.name,
      start_date: this.$moment().format("YYYY-MM-DD"),
      today: this.$moment().format("YYYY-MM-DD"),
      backdate_today: this.$moment().subtract(7, "d").format("YYYY-MM-DD"),
      active: null,
      requiredRules: [(v) => !!v || "This field is required"],
      snackbar: false,
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      gate_pass: {
        entry_discount: "",
        activity_discount: "",
        accommodation_discount: "",
        checking_in: "",
        member: {},
        member_activity_discount: 0,
        member_accommodation_discount: 0,
        currency: this.$store.state.CurrencyStore.browser_currency_id,
        currency_id: "",
        type: "FF9330A3",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        destination: "",
        destination_name: "",
        check_in: this.$moment().format("YYYY-MM-DD"),
        check_out: this.$moment().format("YYYY-MM-DD"),
        session_id: localStorage.getItem("lkjhgfdsa"),
        promo_code: "",
        note: "",
        send_mail: "",
      },
      selectAccomodation: [],
      selectedActivities: [],
    };
  },
  created() {
    this.$store.dispatch("get_all_booking_members");
    this.$store.dispatch("get_all_corporate_members");
    this.$store.dispatch("get_all_destinations");
  },
  computed: {
    currency: function () {
      return this.$store.state.CurrencyStore.browser_currency;
    },
    totalPrice: function () {
      // activity total
      var activity = 0;
      for (var i = 0; i < this.chosenInventory.length; i++) {
        activity = activity + this.findActivityTotal(this.chosenInventory[i]);
      }
      // facility total
      var facility = 0;
      for (var j = 0; j < this.chosenFacilities.length; j++) {
        facility = facility + this.facilityTotal(this.chosenFacilities[j]);
      }
      // vehicle total
      var vehicleData = this.vehicleTotal;
      // conservation total
      var conservationData = this.conservationTotal;
      return activity + facility + vehicleData + conservationData;
    },
    MemberTotalPrice: function () {
      // activity total
      let activityDiscount = 0;
      let accommodationDiscount = 0;
      if (this.gate_pass.member.activity_discount === undefined) {
        activityDiscount = 0;
      } else {
        activityDiscount = this.gate_pass.member.activity_discount;
        this.gate_pass.member_activity_discount =
          this.gate_pass.member.activity_discount;
      }
      if (this.gate_pass.member.accommodation_discount === undefined) {
        accommodationDiscount = 0;
      } else {
        accommodationDiscount = this.gate_pass.member.accommodation_discount;
        this.gate_pass.member_accommodation_discount =
          this.gate_pass.member.accommodation_discount;
      }
      var activity = 0;
      for (var i = 0; i < this.chosenInventory.length; i++) {
        activity =
          activity +
          this.findMemberActivityDiscount(
            this.chosenInventory[i],
            activityDiscount
          );
      }
      // facility total
      var facility = 0;
      for (var j = 0; j < this.chosenFacilities.length; j++) {
        facility =
          facility +
          this.findMemberAccommodationDiscount(
            this.chosenFacilities[j],
            accommodationDiscount
          );
      }
      // vehicle total
      var vehicleData = this.vehicleTotal;
      // conservation total
      let entryDiscount = 0;
      if (this.gate_pass.member.entry_discount === undefined) {
        entryDiscount = 0;
      } else {
        entryDiscount = this.gate_pass.member.entry_discount;
      }
      var conservationData = this.MemberConservationTotal(entryDiscount);
      return activity + facility + vehicleData + conservationData;
    },
    disabled_settings: function () {
      var startDate = this.$moment().format("YYYY-MM-DD");
      // var endDate = this.$store.state.BookingStore.local_booking.check_out
      // this.activity.date = this.$moment(startDate).format('YYYY, MM, DD')
      return {
        to: new Date(this.$moment(startDate).format("YYYY, MM, DD")),
        // from: new Date(this.$moment(endDate).add(1, 'd').format('YYYY, MM, DD'))
      };
    },
  },
  methods: {
    conservationAmount(discount, pax, feePerHead) {
      let total = 0;
      total = Number(pax) * feePerHead;
      let discountAmount = (discount / 100) * total;
      total = total - discountAmount;
      return total;
    },
    MemberConservationTotal(entryDiscount) {
      if (entryDiscount === undefined) {
        entryDiscount = 0;
      }
      var conservationFeeDiscount;
      conservationFeeDiscount =
        Number(this.conservationTotal) -
        (entryDiscount / 100) * Number(this.conservationTotal);
      return conservationFeeDiscount;
    },
    nextTab() {
      this.active = Number(this.active + 1);
    },
    previousTab() {
      this.active = Number(this.active - 1);
    },
    checkDestination(publicId) {
      //Query for the Pricing Schedule
      var data = {
        check_in_date: this.gate_pass.check_in,
        check_out_date: this.gate_pass.check_out,
        destination: this.gate_pass.destination,
      };
      this.$store.dispatch("get_newly_scheduled_pricing", data);
      var instance = this;
      this.allDestinations.map((destination) => {
        if (publicId === destination.destination_public_id) {
          instance.gate_pass.destination_name = destination.destination_name;
        }
      });
    },
    getVehicleTotals: function () {
      var allVehicles = this.allVehicles;
      var size = allVehicles.length;
      var vehicles = 0;
      for (var i = 0; i < size; i++) {
        vehicles = Number(vehicles) + Number(allVehicles[i].vehicles);
      }
      return vehicles;
    },
    putFacilityData: function (data) {
      this.selectAccomodation = data;
    },
    putActivityData: function (data) {
      this.selectedActivities = data;
    },
    doBooking: function () {
      let entryDiscount = 0;
      if (this.gate_pass.member.entry_discount === undefined) {
        entryDiscount = 0;
      } else {
        entryDiscount = this.gate_pass.member.entry_discount;
      }
      this.gate_pass.entry_discount = entryDiscount;
      if (this.gate_pass.destination === "") {
        this.snackbar = true;
      } else {
        this.$store.dispatch("loading_true");
        this.gate_pass.currency =
          this.$store.state.CurrencyStore.browser_currency_id;
        this.gate_pass.currency_id =
          this.$store.state.CurrencyStore.browser_currency_id;
        var data = {
          guests: this.allConservationFees,
          facilities: this.chosenFacilities,
          external_facilities: this.chosenExternalFacilities,
          inventory: this.chosenInventory,
          vehicles: this.allVehicles,
          multi: this.addedMultiArrivals,
          proof_of_residency: this.proofOfResidency,
        };
        Object.assign(data, this.gate_pass);
        if (this.route === "NewBooking") {
          this.$store.dispatch("post_booking", data);
        } else if (this.route === "PostponeBooking") {
          let postponeFac = JSON.parse(
            localStorage.getItem("postponed_facility_data")
          );
          let postponeInvent = JSON.parse(
            localStorage.getItem("postponed_inventory_data")
          );
          var data2 = {
            guests: this.allConservationFees,
            facilities: postponeFac,
            external_facilities: this.chosenExternalFacilities,
            inventory: postponeInvent,
            vehicles: this.allVehicles,
            old_facilities: this.bookedFacilities,

            old_inventory: this.bookedInventory,
            updated_bookings: this.bookedFacilities,
            multi: this.addedMultiArrivals,
            booking_id: this.$route.params.booking_id,
          };
          Object.assign(data2, this.gate_pass);
          this.$store.dispatch("postpone_booking", data2);
        } else {
          var data2 = {
            guests: this.allConservationFees,
            facilities: this.chosenFacilities,
            external_facilities: this.chosenExternalFacilities,
            inventory: this.chosenInventory,
            vehicles: this.allVehicles,
            old_facilities: this.bookedFacilities,
            old_inventory: this.bookedInventory,
            updated_bookings: this.bookedFacilities,
            multi: this.addedMultiArrivals,
            booking_id: this.$route.params.booking_id,
            proof_of_residency: this.proofOfResidency,
          };
          Object.assign(data2, this.gate_pass);
          this.$store.dispatch("update_member_booking", data2);
        }
      }
    },
    putStartDate: function () {
      var date = this.gate_pass.check_in;
      date = this.$moment(date).format("YYYY-MM-DD");
      this.gate_pass.check_in = date;
    },
    putEndtDate: function () {
      var date = this.gate_pass.check_out;
      date = this.$moment(date).format("YYYY-MM-DD");
      this.gate_pass.check_out = date;
    },
    currencyChange: function () {
      var data = this.currency;
      localStorage.setItem("currency", data);
      this.$store.state.CurrencyStore.browser_currency = data;
    },
    endDate(data) {
      let currentBooking = this.$store.state.BookingStore.booking;
      let instance = this;
      let bookingStartDate = currentBooking.booking_check_in_date;

      let bookingEndDate = currentBooking.booking_check_out_date;
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const firstDate = new Date(bookingStartDate);
      const secondDate = new Date(bookingEndDate);
      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
      let postponedCheckInDate = new Date(instance.gate_pass.check_in);

      let postponedCheckOutDate = postponedCheckInDate.setDate(
        postponedCheckInDate.getDate() + diffDays
      );
      let postponedCheckOutDateFormatted = new Date(postponedCheckOutDate);
      instance.gate_pass.check_out = this.$moment(postponedCheckOutDate).format(
        "YYYY-MM-DD"
      );
    },
  },
};
</script>

<style scoped>
</style>
